<template>
  <el-form
    ref="enrollForm"
    :model="enrollForm"
    :rules="enrollFormRules"
    label-width="80px"
    size="small"
  >
    <el-form-item label="医生" prop="storeUserCode">
      <el-select v-model="enrollForm.storeUserCode">
        <el-option
          v-for="doctor in doctorList"
          :key="doctor.id"
          :label="doctor.name"
          :value="doctor.code"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="联系电话" prop="phone">
      <el-input v-model="enrollForm.phone" />
    </el-form-item>
    <ik-form-data-popup
      v-model="enrollForm.name"
      code="name"
      name="姓名"
      url="clinic/treatment/patient/patient/find/findPagination"
      :filed-list="[
        { code: 'name', name: '名称' },
        { code: 'contactPhone', name: '电话' },
        { code: 'idcardCode', name: '身份证号' }
      ]"
      search-key="contactPhone"
      :searcher="{'storeCode': storeCode}"
      :required="true"
      @onPopupClick="selectPatient"
    />
    <el-form-item label="就诊卡号" prop="cardCode">
      <el-input v-model="enrollForm.cardCode" />
    </el-form-item>
    <el-form-item label="身份证号" prop="idcardCode">
      <el-input v-model="enrollForm.idcardCode" />
    </el-form-item>
    <el-form-item label="性别" prop="sexSign">
      <el-select v-model="enrollForm.sexSign">
        <el-option label="男" value="1" />
        <el-option label="女" value="2" />
      </el-select>
    </el-form-item>
    <el-form-item label="出生年月" prop="birthDate">
      <el-date-picker v-model="enrollForm.birthDate" type="date" format="yyyy-MM-dd" />
    </el-form-item>
    <el-form-item label="联系地址" prop="contactAddress">
      <el-input v-model="enrollForm.contactAddress" type="textarea" />
    </el-form-item>
    <el-form-item label="血型" prop="bloodTypeSign">
      <el-select v-model="enrollForm.bloodTypeSign">
        <el-option label="A" value="1" />
        <el-option label="B" value="2" />
        <el-option label="AB" value="3" />
        <el-option label="O" value="4" />
      </el-select>
    </el-form-item>
    <el-form-item label="收费标识" prop="feeSign">
      <el-select v-model="enrollForm.feeSign">
        <el-option label="收费" value="1" />
        <el-option label="不收费" value="0" />
      </el-select>
    </el-form-item>
  </el-form>
</template>
<script>
import IkFormDataPopup from "@/components/ik/form/input/IkFormDataPopup/index.vue"
import { findAll } from "@/api/ik/data/dataApi"
import dayjs from "dayjs"

export default {
  name: "EnrollForm",
  components: { IkFormDataPopup },
  inject: ["pageData"],
  data() {
    return {
      enrollForm: {
        phone: "",
        name: "",
        cardCode: "",
        idcardCode: "",
        sexSign: "",
        birthDate: "",
        contactAddress: "",
        bloodTypeSign: "",
        feeSign: "1",
        storeUserCode: this.pageData.storeUserCode
      },
      enrollFormRules: {
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" }
        ],
        sexSign: [
          { required: true, message: "请选择性别", trigger: "change" }
        ],
        birthDate: [
          { required: true, message: "请选择出生日期", trigger: "change" }
        ],
        storeUserCode: [
          { required: true, message: "请选择医生", trigger: "change" }
        ]
      },
      /**
       * 医生列表
       */
      doctorList: []
    }
  },
  created() {
    this.getDoctorList()
  },
  methods: {
    /**
     * 选择病人
     * @param code
     * @param row
     */
    selectPatient(code, row) {
      this.enrollForm.phone = row.contactPhone
      this.enrollForm.name = row.name
      this.enrollForm.idcardCode = row.idcardCode
      this.enrollForm.sexSign = row.sexSign
      this.enrollForm.birthDate = row.birthDate
      this.enrollForm.cardCode = row.cardCode
      this.enrollForm.contactAddress = row.contactAddress
      this.enrollForm.bloodTypeSign = row.bloodTypeSign
    },
    /**
     * 挂号表单提交
     */
    submitEnrollForm() {
      this.$refs.enrollForm.validate((valid) => {
        if (valid) {
          this.$emit("command", {
            command: "submit",
            data: { ...this.enrollForm, birthDate: dayjs(this.enrollForm.birthDate).format("YYYY-MM-DD") }
          })
        }
      })
    },
    /**
     * 获取医生列表
     */
    getDoctorList() {
      const url = "base/user/user/storeuser"
      const pd = {
        storeCode: this.pageData.storeCode,
        doctorTypeSign: '1',
        stateSign: '2'
      }
      findAll(url, pd)
        .then(res => {
          this.doctorList = res.data
        })
    }
  }
}
</script>
<style scoped lang="scss">

</style>
